import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ChatMessage } from '@models/chat-message.interface';
import { LevelNewComponent } from '@shared/level-new/level-new.component';
import { ChatEmotePipe } from '@shared/pipes/chat-emote.pipe';
import { NamePipe } from '@shared/pipes/name.pipe';
import { UIService } from '@shared/ui.service';

@Component({
  selector: 'app-chat-user-message',
  templateUrl: './chat-user-message.component.html',
  styleUrls: ['./chat-user-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'type',
    '[class.typed-elem]': 'type',
    '[class.trimmed]': 'isTrimmed()',
  },
  imports: [NgOptimizedImage, LevelNewComponent, ChatEmotePipe, NamePipe],
})
export class ChatUserMessageComponent implements OnChanges {
  @Input() message: ChatMessage;
  content = '';
  type = '';

  constructor(public uiService: UIService) {}

  ngOnChanges() {
    if (!this.message) {
      return;
    }

    if (this.message.profile.admin === 3 && ['76561198231370492', '76561197984485194'].find((i) => i === this.message.profile.steamid)) {
      this.type = 'dev';
    } else if (this.message.profile.role === 4) {
      this.type = 'vip';
    } else if (this.message.profile.admin >= 2) {
      this.type = 'admin';
    } else if (this.message.profile.role === 1) {
      this.type = 'mod';
    } else if (this.message.profile.steamid === '-1') {
      this.type = 'system';
    } else if (this.message.profile.sponsor) {
      this.type = 'sponsor';
    }
    this.content = this.message.content as string;
  }

  isTrimmed() {
    return this.uiService.uiState().chat === 'trimmed';
  }

  isOnlyEmote(): boolean {
    const textWithoutEmotes = this.content.replace(/:\w+:/g, '').trim();
    return textWithoutEmotes === '';
  }
}
